<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <loading :active.sync="isLoading"
                :can-cancel="false"
                :on-cancel="onCancel"
                :is-full-page="fullPage"></loading>
                <CForm @submit.prevent="forgotPasswordFunction">
                  <h1>Forgot password</h1>
                  <p class="text-muted">Enter emailid</p>
                  <CInput
                    placeholder="Email"
                    autocomplete="username email"
                    v-model="forgotPassword.email"
                  >
                    <template #prepend-content><CIcon name="cil-envelope-closed"/></template>
                  </CInput>
                  <div class="login-errors" v-if="$v.forgotPassword.email.$error">
                    <span class="validation-error" v-if="!$v.forgotPassword.email.required">Please Enter emailid</span>
                    <span class="validation-error" v-else-if="!$v.forgotPassword.email.email">Please Enter a valid emailid</span>
                  </div>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton color="primary" class="px-4" type="submit">Submit</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                        <router-link to="/login" class="px-0">Login</router-link>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'Forgot password'
}
</script>

<script>
import axios from 'axios'
import { validationMixin } from "vuelidate";
import VueNotifications from 'vue-notifications'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
const {
  email,
  required,
  maxLength,
	minLength,
	sameAs
} = require("vuelidate/lib/validators");
export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      forgotPassword: {
        email: "",
      }
    };
  },
  components: {
      Loading
  },
  notifications: {
      showErrorMsg: {
          type: VueNotifications.types.error
      },
      showSuccessMsg: {
          type: VueNotifications.types.success
      }
  },
  mounted() {
      document.title = "Forgot password";
      this.checkLoggedIn();
  },
  methods: {
    forgotPasswordFunction() {
      // stop here if form is invalid
      this.$v.forgotPassword.$touch();
      if (this.$v.forgotPassword.$invalid) {
        return;
      }

      try {
        let a =
        axios
        .post(`${API_ADMIN_URL}/forgotPassword`, this.forgotPassword)
        .then(response => {
          this.isLoading = true;
          var passwordToken = response.data.data.passwordtoken
          if (response.data.status == 200) {
            this.$v.forgotPassword.$reset()
            this.showSuccessMsg({message: response.data.message});
            this.$router.push("/login");
            this.isLoading = false;
          }
          else {
            this.isLoading = false;
            this.showErrorMsg({message: response.data.message});
          }
          this.isLoading = false;
        });
      } catch (err) {
        console.log(err);
        this.showErrorMsg({message: 'Something went to wrong, please try again!'});
      }
    },
    onCancel() {
    },
    checkLoggedIn() {
        if (localStorage.getItem('userdata') != null)// && localStorage.getItem('token') != null
        {
            this.$router.push("/dashboard");
        }
    }
  },
  mixins: [validationMixin],
	validations: {
		forgotPassword:{
			email: {
        email,
				required,
			}
	  }
  }
};
</script>
